import { Navigate } from 'react-router-dom';

export type PortalNavigationState = {
  pageNotFound?: boolean;
};

/**
 * Unknown routes inside the authenticated portal recover to My Health.
 * Navigation state lets the destination explain the recovery without
 * keeping the invalid URL or adding a permanent query parameter.
 */
export const AuthenticatedNotFoundRedirect = () => (
  <Navigate to="/health" replace state={{ pageNotFound: true } satisfies PortalNavigationState} />
);
